import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { firstValueFrom, of } from 'rxjs';
import { catchError, filter, take, timeout } from 'rxjs/operators';
import { selectActor } from '../store/auth/auth.selectors';

export const InvestorActorGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
    const store = inject(Store);
    const router = inject(Router);

    const actor = await firstValueFrom(
        store.select(selectActor).pipe(
            filter((a) => a !== null && a !== undefined),
            take(1),
            timeout(3000),
            catchError(() => of(null))
        )
    );

    if (actor?.actor_type === 'investor') return true;

    const roleCode = String(actor?.role_code || '').trim().toLowerCase();
    if (roleCode === 'app_admin') return router.parseUrl('/admin/dashboard');
    if (roleCode === 'subpartner') return router.parseUrl('/developer/dashboard');
    if (roleCode === 'sales') return router.parseUrl('/developer/dashboard');
    return router.parseUrl('/developer/dashboard');
};
